export default {
  lostAndFound: {
    found: 'Tìm thấy'
  }
}
